const getters = {
    userInfo: (state) => state.user.userInfo,
    feature: (state) => state.user.feature,
    permissions: (state) => state.user.permissions,
    renderRoutes: (state) => state.permission.renderRoutes,
    moduleRoutes: (state) => state.permission.moduleRoutes,
    rootPath: (state) => state.permission.rootPath,
    routeType: (state) => state.permission.routeType,
    filterRouteList: (state) => state.permission.filterRouteList,
    sideRouteList: (state) => state.permission.sideRouteList,
    deploymentAddress: (state) => state.permission.deploymentAddress,

    // 上传数据对象的keys
    uploadProgressObjKeys: state => {
            return Object.keys(state.uploadProgress.uploadProgressObj)
        },
    // 是否全部上传完成
    is_upload_complete_all: state => {
            var uploadProgressObj = state.uploadProgress.uploadProgressObj
            var uploadProgressObjKeys = Object.keys(state.uploadProgress.uploadProgressObj)
            for (let i = 0; i < uploadProgressObjKeys.length; i++) {
                const element = uploadProgressObjKeys[i]
                const {
                    loaded,
                    total
                } = uploadProgressObj[element].ProgressEvent
                if (loaded !== total) {
                    return false
                }
            }
            return true
        },
     // 未上传完成数量
    uploadingNumber: state => {
            var uploadProgressObj = state.uploadProgress.uploadProgressObj
            var uploadProgressObjKeys = Object.keys(state.uploadProgress.uploadProgressObj)
            return uploadProgressObjKeys.reduce((prev, curr) => {
                const {
                    loaded,
                    total
                } = uploadProgressObj[curr].ProgressEvent
                if (loaded < total) {
                    prev += 1
                }
                return prev
            }, 0)
    },

    //  页面查询所需参数
    pageCache: (state) => state.pageCache,
    system: (state) => state.pageCache.system,  // 系统管理
    personal: (state) => state.pageCache.personal,  // 个人信息
    nodeMap: (state) => state.pageCache.nodeMap,
    edgeTaskSelectedProject: (state) => state.edgeTask.selectProject,  // 边缘采集任务选择的设备
    edgeTaskSelectedDevice: (state) => state.edgeTask.selectedDevice,  // 边缘采集任务选择的设备
    addEdgeTask: (state) => state.edgeTask.addTask,  // 边缘采集任务添加任务
    editEdgeTask: (state) => state.edgeTask.editTask,  // 边缘采集任务  --> 编辑任务
    cloudTaskRoute: (state) => state.cloudTask.route,  // 云采集任务
    /*
    * v3.0.0迭代重构后所需
    * */
    dataSourceSelectProject: (state) => state.dataSourceManagement.selectProject,  // 选中的项目
    dataSourceSelectDeviceGroup: (state) => state.dataSourceManagement.selectDeviceGroup,  // 选中的设备分组以及设备信息，用于添加采集任务
    dataSourceSelectTableData: (state) => state.dataSourceManagement.selectedTableData,  // 选中的表格信息
    dataSourceSelectedDevice: (state) => state.dataSourceManagement.selectedDevice,  // 选中的设备信息 用于查询列表
    dataSourceSelectedCaptureDevice: (state) => state.dataSourceManagement.selectedCaptureDevice,  // 选中的设备信息 用于查询列表

    deviceSelectProjectId: (state) => state.deviceManagement.selectProjectId,             // 选中的项目
    deviceSelectDeviceGroupId: (state) => state.deviceManagement.selectDeviceGroupId,     // 选中的设备分组

    taskManagementSelectPointGroup: (state) => state.taskManagement.selectPointGroup,//选中的点位信息
    taskManagementSelectFromRelateTask: (state) => state.taskManagement.selectFromRelateTask,//关联任务时的点位、表格信息
    taskManagementSelectTableData: (state) => state.taskManagement.selectedTableData,// 选中的任务表格数据  用于添加/编辑采集
    taskManagementSelectProject: (state) => state.taskManagement.selectedTaskProject,// 选中的任务表格数据  用于添加/编辑采集

    alarmManagementPlusProjectId: (state) => state.alarmManagementPlus.projectId, 
    alarmManagementPlusDataType: (state) => state.alarmManagementPlus.dataType, 
    alarmManagementPlusLeftActive: (state) => state.alarmManagementPlus.left_active, 
    alarmManagementPlusRightActive: (state) => state.alarmManagementPlus.right_active, 
    alarmManagementPlusRightActiveName: (state) => state.alarmManagementPlus.right_active_name, 
    alarmManagementPlusActiveAlgoId: (state) => state.alarmManagementPlus.active_algoId, 
    alarmManagementPlusActiveTaskId: (state) => state.alarmManagementPlus.active_taskId, 
    alarmManagementPlusActiveAlgoName: (state) => state.alarmManagementPlus.active_algoName, 
    alarmManagementPlusResultType: (state) => state.alarmManagementPlus.resultType, 
    alarmManagementPlusPointDateType: (state) => state.alarmManagementPlus.point_dateType, // 点位-时间类型
    alarmManagementPlusPointTimeType: (state) => state.alarmManagementPlus.point_time_slot, // 点位-时间范围
    alarmManagementPlusGroupActiveGroupId: (state) => state.alarmManagementPlus.group_active_groupId, // 点位分组: 分组id
    alarmManagementPlusGroupActiveAlgoId: (state) => state.alarmManagementPlus.group_active_algoId, // 点位分组: 算法id
    alarmManagementPlusGroupDateType: (state) => state.alarmManagementPlus.group_dateType, // 点位分组-时间类型
    alarmManagementPlusGroupTimeType: (state) => state.alarmManagementPlus.group_time_slot, // 点位分组-时间范围
};

export default getters;
